import Vue from 'vue'
import Router from 'vue-router'

// AUTH //
import Login from '@/views/auth/Login'
import Logout from '@/views/auth/Logout'
import ForgotPassword from '@/views/auth/ForgotPassword'
import ResetPassword from '@/views/auth/ResetPassword'

// USER PROFILE //
import UserProfile from '@/views/user-profile/Overview'
import ChangeUserPassword from '@/views/user-profile/ChangePassword'

// BOOKED FACILITY MANAGEMENT //
import FacilityBookingIndex from '@/views/booking-ms/Index'
import FacilityBookingDetail from '@/views/booking-ms/Detail'

// Tasks
import TaskIndex from '@/views/tasks/Index'
import TaskForm from '@/views/tasks/Form'
import TaskDetail from '@/views/tasks/Detail'

// SETTINGS //
import SettingsIndex from '@/views/settings/Settings'
// Users
import AdminIndex from '@/views/settings/admin/Index'
import AdminForm from '@/views/settings/admin/Form'
import AdminDetail from '@/views/settings/admin/Detail'
import TenantIndex from '@/views/settings/tenant/Index'
import TenantForm from '@/views/settings/tenant/Form'
import TenantDetail from '@/views/settings/tenant/Detail'

// Others
import FacilityIndex from '@/views/settings/facility/Index'
import FacilityForm from '@/views/settings/facility/Form'
import FacilityDetail from '@/views/settings/facility/Detail'

// Containers & other Pages
import Full from '@/containers/Full'
import Index from '@/views/Index'
import PageNotFound from '@/components/Page404'
import PageInternalError from '@/components/Page500'
// import PageUnderConstruction from '@/components/PageOnProgress'
import UserIndex from '@/views/settings/User'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresGuest: true, bodyClass: 'authPage' }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: { requiresGuest: true, bodyClass: 'authPage' }
    },
    {
      path: '/reset-password/:id',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: { requiresGuest: true, bodyClass: 'authPage' }
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'home',
      component: Full,
      children: [
        // Dashboard
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Index,
          meta: { requiresAuth: true }
        },
        // User Profile
        {
          path: 'profile',
          name: 'User Profile',
          component: UserProfile,
          children: [
            {
              path: 'password',
              name: 'Change Password',
              component: ChangeUserPassword
            }
          ]
        },
        // tasks
        {
          path: 'tickets',
          name: 'Tickets',
          component: TaskIndex,
          children: [
            {
              path: 'create',
              name: 'Add New Ticket',
              component: TaskForm
            },
            {
              path: ':id/edit',
              name: 'Edit Ticket',
              component: TaskForm
            },
            {
              path: ':id',
              name: 'Ticket Details',
              component: TaskDetail
            }
          ]
        },
        // book-ms
        {
          path: 'visited-sites',
          name: 'Visited Sites',
          component: FacilityBookingIndex,
          children: [
            {
              path: ':id',
              name: 'Visited Site Details',
              component: FacilityBookingDetail
            }
          ]
        },
        // Settings
        {
          path: 'settings',
          name: 'Settings',
          component: SettingsIndex,
          children: [
            // User
            {
              path: 'user',
              name: 'User',
              component: UserIndex,
              redirect: '/settings/user/contractors',
              children: [
                {
                  path: 'admin',
                  name: 'Administrators',
                  component: AdminIndex,
                  children: [
                    {
                      path: 'create',
                      name: 'Add New Administrator',
                      component: AdminForm
                    },
                    {
                      path: ':id/edit',
                      name: 'Edit Administrator',
                      component: AdminForm
                    },
                    {
                      path: ':id',
                      name: 'Administrator Details',
                      component: AdminDetail
                    }
                  ]
                },
                {
                  path: 'contractors',
                  name: 'Contractors',
                  component: TenantIndex,
                  children: [
                    {
                      path: 'create',
                      name: 'Add New Contractor',
                      component: TenantForm
                    },
                    {
                      path: ':id/edit',
                      name: 'Edit Contractor',
                      component: TenantForm
                    },
                    {
                      path: ':id',
                      name: 'Contractor Details',
                      component: TenantDetail
                    }
                  ]
                }
              ]
            },
            // Facility
            {
              path: 'sites',
              name: 'Sites',
              component: FacilityIndex,
              children: [
                {
                  path: 'create',
                  name: 'Add New Site',
                  component: FacilityForm
                },
                {
                  path: ':id/edit',
                  name: 'Edit Site',
                  component: FacilityForm
                },
                {
                  path: ':id',
                  name: 'Site Details',
                  component: FacilityDetail
                }
              ]
            }
          ]
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      meta: { requiresAuth: true }
    },
    {
      path: '*',
      name: 'others',
      redirect: '/404',
      component: Full,
      children: [
        {
          path: '/404',
          name: 'Page Not Found',
          component: PageNotFound
        },
        {
          path: '/500',
          name: 'Page Get Internal Error',
          component: PageInternalError
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js